<template lang="html">
<div>
  <el-row style="border-bottom: 1px solid #ebeef5;">
    <el-col :span="12" class="statistics-info">
      <div class="statistics-label">浏览数据</div>
      <div class="statistics-content">{{statisticsInfo.numberOfParticipants?statisticsInfo.numberOfParticipants:0}} 人 浏览 {{statisticsInfo.browseCount?statisticsInfo.browseCount:0}} 次</div>
    </el-col>
    <el-col :span="12" class="statistics-info">
      <div class="statistics-label">线索数据</div>
      <div class="statistics-content" style="padding-left: 8%;">{{statisticsInfo.clueCount}} 条</div>
    </el-col>

  </el-row>

  <el-tabs v-model="activeName">
    <el-tab-pane label="商家管理" name="first">
<!--      <car-exhibition-business-manager></car-exhibition-business-manager>-->
      <joined-business ref="joined-business" :carShowId="carShowId">
          <template slot="addButton">
              <el-button @click="$router.push('/home/addCarShowPlusBusiness/'+carShowId)" type="primary">新增商家</el-button>
          </template>
        <template  scope="scope">
          <div class="">
            排序值：{{scope.data.relationBusinessSortNum}}
          </div>

          <el-button :confirm-input-data="{id:scope.data.relationBusinessId}" @onInputConfirm="$refs['joined-business'].search()" confirm-input-text="确定排序商家"
                     confirm-input-type="number" requestUrl="lcwpbusiness/updateCarShowSortNum.action"
                     type="text" v-confirm-input>排序
          </el-button>

          <el-button @click="$router.push({name:'车展商家商品', params: { businessId: scope.data.id,carShowId:carShowId }})"
                     type="text">商品管理
          </el-button>
            <el-button @click="$router.push({name:'车展活动', query: { businessId: scope.data.id ,carShowId:carShowId}})" type="text">上架活动</el-button>
          <el-button @click="$router.push({name:'修改plus商家', params: { id: scope.data.id }})" type="text">修改商家
          </el-button>
        </template>
      </joined-business>
    </el-tab-pane>
    <el-tab-pane label="渠道管理" name="second">
      <channel-manager></channel-manager>
    </el-tab-pane>

      <el-tab-pane label="车展普通线索" name="third">
          <clue-management :carShowId="carShowId"></clue-management>
      </el-tab-pane>
      <el-tab-pane label="车展商品线索" name="third1">
          <plus-clue :carShowId="carShowId"></plus-clue>
      </el-tab-pane>

    <el-tab-pane label="广告位管理" name="five">
      <advertisement-manager></advertisement-manager>
    </el-tab-pane>
    <el-tab-pane label="视频管理" name="six">
      <carExhibitionVideo></carExhibitionVideo>
    </el-tab-pane>
  </el-tabs>

</div>

</template>

<script>
import channelManager from './channelManager'
import advertisementManager from './advertisementManager'
import carExhibitionVideo from './carExhibitionVideo'
import carExhibitionOrderManager from './carExhibitionOrderManager'
import carExhibitionBusinessManager from './carExhibitionBusinessManager'
import carExhibitionAssistanceUsers from './carExhibitionAssistanceUsers'
import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
import joinedBusiness from '@/pages/plusbusiness/joinedBusiness'
import plusClue from '@/pages/clueManagement/plusClue'
import clueManagement from '@/pages/clueManagement/clueManagement'
export default {
  name: 'car-exhibition-detail',
  components: {
    channelManager,
    carExhibitionBusinessManager,
    carExhibitionOrderManager,
    advertisementManager,
    carExhibitionAssistanceUsers,
    joinedBusiness,
    plusClue,
    clueManagement,
    carExhibitionVideo
  },
  data: function () {
    return {
      activeName: 'first',
      carShowId: null,
      statisticsInfo: {
        carCoinCount: 0,
        clueCount: 1,
        browsePeopleCount: 0,
        browseCount: 0
      }
    }
  },
  created: function () {
    let carShowId = this.$route.params.carShowInfoId
    this.carShowId = parseInt(carShowId)
  },
  activated: function () {
    this.$nextTick(() => {
      let carShowId = this.$route.params.carShowInfoId
      this.carShowId = parseInt(carShowId)

      this.selectCarShowStatisticsInfo(carShowId)
    })
  },
  methods: {
    selectCarShowStatisticsInfo: function (carShowId) {
      let _this = this
      let params = {
        carShowId: carShowId
      }
      let listener = {
        success: function (dataInfo) {
          _this.statisticsInfo = dataInfo.datas
        }
      }
      CarExhibitionModel.selectCarShowStatisticsInfo(_this, params, listener)
    }
  }
}
</script>

<style lang="css" scoped>
.statistics-info {
  text-align: left;
  padding-left: 5%;
}
.statistics-label {
  color:#999999;
  padding:20px;
}
.statistics-content {
  padding-top:10px;
  padding-bottom: 20px;
  padding-left: 5px;
  font-size: 18px;
  float: left;
}

</style>
